import { fastLoginSessionKillUrl } from "../statics/config";

export const openKillSessionPopup = (redirectUrl) => {
  // This function is used to listen to the Popup screen
  const logout = window.open(
    fastLoginSessionKillUrl,
    "_blank",
    "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=400,height=400"
  );

  window.addEventListener("message", () => {
    logout.close();
    window.location.replace(redirectUrl);
  });
};

export default openKillSessionPopup;
